import CircularProgress from '@material-ui/core/CircularProgress';
import cx from 'classnames';

import { noop } from 'helpers/utils';
import useCustomMediaQuery from 'hooks/useMediaQuery';
import i18n from 'i18n/config';
import Box from 'UIKit/Box';
import MaterialConfirmDialog from 'UIKit/MaterialConfirmDialog';

import styles from './rekycDetails.module.scss';

const textLoading = i18n.t<string>('homepage:reKycFlow.loadingReKycWorkflow');

const RekycDetailsModalLoader = () => {
  const { whenBelowMd } = useCustomMediaQuery();

  return (
    <MaterialConfirmDialog
      onClose={noop}
      containerClassName={styles.mainContent}
      headerClassName={styles.header}
      open
      fullHeight={whenBelowMd}
      fullWidth={whenBelowMd}
      showHeader={false}
      title=""
      bodyClassName={cx(styles.rekycVerificationContent, styles.modalBodyScroll)}
      showFooter={false}
    >
      <Box
        flex="flex"
        flexDir="column"
        className={styles.loaderContent}
        alignItems="center"
        gap={20}
        textColor="primaryTheme"
      >
        <CircularProgress color="inherit" />
        <Box textColor="primary" as="p" fullWidth data-testid="loading-kyc-workflow-text">
          {textLoading}
        </Box>
      </Box>
    </MaterialConfirmDialog>
  );
};

export { RekycDetailsModalLoader };
